module.exports = __webpack_public_path__ + "img/productos-participantes-walmart.3adaa5df.png";